const {enabled}=require('./transition.js');
const clamp=value=>Math.max(0,Math.min(1,value));
const range=(value,start,end)=>clamp((value-start)/(end-start));
const scenes=[],active=new Set();
// Short tablet canvases need the full stacked story, not a compressed sticky frame.
const enhance=()=>enabled()&&innerHeight>=620&&(innerWidth<640||innerWidth>=1024||innerHeight>=780);
let frame=0;
const update=()=>{
 frame=0;
 if(!enabled())return;
 const measurements=[...active].map(scene=>[scene,scene.read()]);
 measurements.forEach(([scene,data])=>scene.write(data));
};
const schedule=()=>{if(!frame&&enabled())frame=requestAnimationFrame(update);};
const observer=new IntersectionObserver(entries=>{
 entries.forEach(entry=>{const scene=scenes.find(item=>item.element===entry.target);if(entry.isIntersecting)active.add(scene);else active.delete(scene);});
 schedule();
},{rootMargin:'250px 0px'});
const track=(element,write,read=()=>element.getBoundingClientRect(),reset=()=>{})=>{
 const scene={element,write,read,reset};scenes.push(scene);
 element.classList.toggle('is-scroll-driven',enhance());observer.observe(element);
 return scene;
};
addEventListener('scroll',schedule,{passive:true});
addEventListener('resize',()=>{scenes.forEach(scene=>{if(!enhance())scene.reset();scene.element.classList.toggle('is-scroll-driven',enhance());});schedule();});
addEventListener('onestep:motion',()=>{
 cancelAnimationFrame(frame);frame=0;
 scenes.forEach(scene=>{scene.element.classList.toggle('is-scroll-driven',enhance());scene.reset();});schedule();
});
document.fonts?.ready.then(schedule);
if(typeof ResizeObserver!=='undefined')new ResizeObserver(schedule).observe(document.body);
const pinned=(rect,height)=>clamp(-rect.top/Math.max(1,rect.height-height));
module.exports={track,clamp,range,pinned,schedule};
